/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'sys-info': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 0a8 8 0 108 8 8 8 0 00-8-8zM5.747 4.093a2 2 0 011.171-.526.274.274 0 00.044-.012h.3c.109.02.221.033.327.062a2.141 2.141 0 011.479 1.342 2.425 2.425 0 01-.543 2.633 1.964 1.964 0 01-1.624.572 2.03 2.03 0 01-1.491-.9 2.438 2.438 0 01.337-3.171zm-2.191 8.351v-.184c.016-.112.029-.225.05-.337a3.023 3.023 0 01.965-1.714 3.594 3.594 0 012.085-.935 3.735 3.735 0 012.707.7 3.056 3.056 0 011.245 1.906c.037.186.043.378.063.567zm8.889-1.907h-1.9v-.631h1.9zm0-1.907H9.911v-.629h2.533zm0-1.907h-1.901v-.634h1.9z" _fill="#212121"/>'
  }
})
